import { type CVEditingSection, type FullCV } from '@cibli/shared';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface SkillsSectionProps {
  competences: FullCV['competences'];
  onEdit?: (section: CVEditingSection) => void;
}

export default function SkillsSection({ competences, onEdit }: SkillsSectionProps) {
  const { t } = useCVTranslation();
  const editable = onEdit !== undefined;

  if (!competences?.length && !editable) return null;

  const handleEdit = () => {
    if (onEdit) onEdit('competences');
  };

  return (
    <EditableSection onEdit={handleEdit} editable={editable} splitable>
      <div>
        <h2 className="text-[11px] font-black uppercase tracking-widest text-current pb-1.5 mb-1.5">
          {t('CV.skills')}
        </h2>
        <ul className="space-y-1">
          {(competences ?? []).map((skill, index) => (
            <li
              key={index}
              className="text-[11px] text-current leading-relaxed flex items-start gap-1"
            >
              <span className="text-current/60 mt-0.5">•</span>
              <span>{skill}</span>
            </li>
          ))}
        </ul>
      </div>
    </EditableSection>
  );
}
